module.exports = __webpack_public_path__ + "static/AAA-38342-d9c88a3467bb42794b5bede851947201.png";